/**
 * This is the main entry point for the UI. You should not need to make any
 * changes here unless you want to update the theme.
 *
 * @see https://github.com/allenai/varnish-mui
 */
import { getTheme, getRouterOverriddenTheme, VarnishApp } from '@allenai/varnish2';
import { createTheme } from '@mui/material/styles';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

import { App } from './App';
import { ScrollToTopOnPageChange } from './components/shared';
import { Auth0Provider } from './contexts/Auth0Context';

const VarnishedApp = () => {
    const base = getTheme(getRouterOverriddenTheme(HashLink));
    const theme = createTheme(base, {
        palette: {
            mode: 'dark',
            background: {
                default: '#032629',
                paper: '#0A3235',
            },
            primary: {
                main: '#0FCB8C',
                contrastText: '#032629',
            },
            secondary: {
                main: '#0FCB8C',
            },
            text: {
                primary: '#FFFFFF',
                secondary: '#FFFFFF',
            },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: 'none',
                        '&.Mui-disabled': {
                            backgroundColor: '#666666',
                            color: '#CCCCCC',
                        },
                    },
                },
            },
        },
    });

    return (
        <BrowserRouter>
            <ScrollToTopOnPageChange />
            <VarnishApp theme={theme}>
                <Auth0Provider>
                    <App />
                </Auth0Provider>
            </VarnishApp>
        </BrowserRouter>
    );
};

const container = document.getElementById('root');
if (!container) {
    throw new Error("No element with an id of 'root' was found.");
}
const root = createRoot(container);
root.render(<VarnishedApp />);
